import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { useTranslation } from 'react-i18next'

type ProposalVendorPortalPromoProps = {
  onGoToPortal: () => void
}

const ProposalVendorPortalPromo: React.FC<ProposalVendorPortalPromoProps> = ({ onGoToPortal }) => {
  const { t } = useTranslation()

  return (
    <Box sx={{ width: '100%', borderRadius: 1, backgroundColor: '#EFEFEF', p: 2, maxWidth: 443, mt: 2 }}>
      <Typography variant="body2" paragraph color="textSecondary">
        {t('vendor-portal-promo')}
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button variant="contained" onClick={onGoToPortal}>
          {t('to-vendor-portal')}
        </Button>
      </Box>
    </Box>
  )
}

export default ProposalVendorPortalPromo
